import React, { useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import Config from "./Config.js";
import { useState } from "react";

const Connection = () => {
  const [connected, setConnected] = useState(false);

  const init_connection = async function () {
    var rosSession = await new window.ROSLIB.Ros();

    rosSession.on("connection", () => {
      console.log("Connection Established");
      setConnected(true);
    });
    rosSession.on("close", () => {
      console.log("connection lost");
      setConnected(false);
      // Try to reconnect every 3 seconds
      setTimeout(() => {
        try {
          rosSession.connect(
            `ws://${Config.ROSBRIDGE_SERVER_IP}:${Config.ROSBRIDGE_SERVER_PORT}`
          );
        } catch (error) {
          console.log("Connection error");
        }
      }, Config.RECONNECTION_TIMER);
    });
    try {
      rosSession.connect(
        `ws://${Config.ROSBRIDGE_SERVER_IP}:${Config.ROSBRIDGE_SERVER_PORT}`
      );
    } catch (error) {
      console.log("Connection error");
    }
  };

  useEffect(() => {
    init_connection();
  }, []);
  return (
    <div>
      <Alert
        className="text-center mt-3"
        variant={connected ? "success" : "danger"}
      >
        {connected === true ? "Robot Connected" : "Robot Disconnected"}
      </Alert>
    </div>
  );
};

export default Connection;
